var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 24H4.5C2.01453 24 0 21.9855 0 19.5V4.5C0 2.01453 2.01453 0 4.5 0H19.5C21.9855 0 24 2.01453 24 4.5V19.5C24 21.9855 21.9855 24 19.5 24Z",
    fill: "#E3F2FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 17.0206H11.1248C10.8488 17.0206 10.6245 16.7963 10.6245 16.5203C10.6245 16.2442 10.8488 16.0201 11.1248 16.0201H17.625C17.9009 16.0201 18.1252 16.2442 18.1252 16.5203C18.1252 16.797 17.9009 17.0206 17.625 17.0206Z",
    fill: "#4FB4FD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2585 8.09401L15.5514 7.38686C15.1733 7.00874 14.5148 7.00874 14.1376 7.38686L13.1033 8.42104L15.2244 10.5419L16.2585 9.50777C16.4475 9.3188 16.5519 9.06831 16.5519 8.80043C16.5519 8.53419 16.4475 8.28297 16.2585 8.09401Z",
    fill: "#4FB4FD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3968 9.12817L7.2435 14.2815C7.21054 14.3145 7.18728 14.3558 7.17685 14.4007L6.63156 16.7137C6.61197 16.7977 6.63687 16.8862 6.69821 16.9477C6.74545 16.9949 6.80935 17.0213 6.87527 17.0213C6.89395 17.0213 6.91354 17.0189 6.93222 17.0145L9.24521 16.4692C9.29025 16.4588 9.33236 16.4355 9.36459 16.4026L14.5177 11.2493L12.3968 9.12817Z",
    fill: "#2A8BF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.b92cf8572719586d31d105c84f54c00d.svg";
export { ForwardRef as ReactComponent };